import React from 'react';
import { MessageCircle } from 'lucide-react';
import { motion } from 'framer-motion';
export function WhatsAppButton() {
  return <motion.a href="https://wa.me/447921876472" target="_blank" rel="noopener noreferrer" className="fixed bottom-6 right-6 z-50 flex items-center justify-center w-14 h-14 bg-green-500 rounded-full shadow-lg hover:bg-green-600 transition-colors" initial={{
    scale: 0
  }} animate={{
    scale: 1
  }} whileHover={{
    scale: 1.1
  }} whileTap={{
    scale: 0.9
  }} aria-label="Chat on WhatsApp" data-id="element-317">
      <MessageCircle className="w-8 h-8 text-white" data-id="element-318" />
    </motion.a>;
}